import React, { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";
import LoadingScreen from "../components/Loading/LoadingScreen";
import "./scss/manager-markets.scss";
import ManagerMarketCard from "../components/ManagerMarketCard";

export default function ManagerMarketsPage() {
  const navigate = useNavigate();

  const [markets, setMarkets] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const take = 10;
  const skip = (page - 1) * take;
  const totalPages = Math.ceil(total / take);

  useEffect(() => {
    load();
  }, [page, search, status]);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.post("/api/manager/markets/search", {
        search,
        status,
        skip,
        take
      });

      setMarkets(data.markets || []);
      setTotal(data.total || 0);
    } finally {
      setLoading(false);
    }
  }

  function handleMarketClick(id) {
    navigate(`/manager/market/info/${id}`);
  }

  function getPages() {
    if (totalPages <= 1) return [];
    const pages = [];
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return pages;
  }

  function renderStatus(status) {
    switch (status) {
      case "approved":
        return { text: "Активен", className: "status-approved" };
      case "blocked":
        return { text: "Заблокирован", className: "status-blocked" };
      case "new":
        return { text: "Новый", className: "status-new" };
      case "closed":
        return { text: "Закрыт", className: "status-closed" };
      default:
        return { text: status, className: "" };
    }
  }

  return (
    <div className="manager-markets">
      <BackButton />

      <Breadcrumbs
        items={[
          { label: "Главная", path: "/manager/dashboard" },
          { label: "Магазины" }
        ]}
      />

      <div className="manager-markets__header">
        <input
          placeholder="Поиск магазина"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setPage(1);
              setSearch(searchInput.trim());
            }
          }}
          onBlur={() => {
            setPage(1);
            setSearch(searchInput.trim());
          }}
        />
      </div>

      <div className="manager-markets__switcher">
        <button
          className={status === "all" ? "active" : ""}
          onClick={() => {
            setPage(1);
            setStatus("all");
          }}
        >
          Все
        </button>

        <button
          className={status === "approved" ? "active" : ""}
          onClick={() => {
            setPage(1);
            setStatus("approved");
          }}
        >
          Активные
        </button>

        <button
          className={status === "blocked" ? "active" : ""}
          onClick={() => {
            setPage(1);
            setStatus("blocked");
          }}
        >
          Заблокированные
        </button>
      </div>

      <div className="manager-markets__list">
        {loading ? (
          <LoadingScreen />
        ) : (
          markets.map((m) => (
            <ManagerMarketCard
              key={m.id}
              market={m}
              onClick={() => handleMarketClick(m.id)}
            />
          ))
        )}
      </div>

      {totalPages > 1 && (
        <div className="manager-markets__pagination">
          {getPages().map((p) => (
            <button
              key={p}
              className={page === p ? "active" : ""}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
